import React, { useState, useEffect } from 'react';
import Main_Spring from '../component/Spring/Main_Spring';
import Info_Spring from '../component/Spring/Info_Spring';
import Letter from '../component/Spring/Letter';
import Dday_Spring from '../component/Spring/Dday_Spring';
import Message_Spring from '../component/Spring/Message_Spring';
import Location_Spring from '../component/Spring/Location_Spring';
import Footer from '../component/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../component/MotionWrapper';
import axios from 'axios';
import Save_Date from '../component/Save_Date';
import Loading from '../component/Loading';
import Location_Desc from '../component/Location/Location_Desc';
import Music from '../component/Music';
import AccountList from '../component/Account/AccountList';
import Sharing from '../component/Sharing';
import Interview_Spring from '../component/Spring/Interview_Spring';
import GalleryList from '../component/Gallery/GalleryList';

const SongJooHee = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);
    
    const openTitle = "남궁훈 ♥︎ 송주희 결혼합니다.";
    const openDesc = "2월 8일 오전 11시 인천 아시아드웨딩컨벤션";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/19/thumb.JPG";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen:''
    });

    const conceptStyle = {
        concept: "SPRING",
        titleColor: "#FF8A83",
        pointColor: "#FF8A83",
        btnBgColor: "#FFE8E7",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#fefaf9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const groomAccountList = [
        {
            role: "신랑",
            name: "남궁 훈",
            bank: "카카오뱅크",
            accountNumber : "3333-08-1238885",
            isKakao : true,
            kakaoUrl: "https://qr.kakaopay.com/Ej7xT8kJQ"
        },
        {
            role: "신랑 부",
            name: "남궁 동",
            bank: "신한은행",
            accountNumber : "110-190-477940",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "송 주희",
            bank: "신한은행",
            accountNumber : "110-259-992377",
            isKakao : true,
            kakaoUrl: "https://qr.kakaopay.com/Ej9SxoNhJ"
        },
        {
            role: "신부 부",
            name: "송 성익",
            bank: "신한은행",
            accountNumber : "110-062-535733",
            isKakao : false
        }
    ]


    const interviewContent = [
        {
            question : "우리의 첫 데이트 기억해?",
            groomAnswer: "심장이쿵쾅",
            brideAnswer: "설레죽는줄"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "드디어결혼",
            brideAnswer: "기다린순간"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "축구보내줘",
            brideAnswer: "생각해볼게"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "화목한가정",
            brideAnswer: "참을인세개"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "늘아껴주길",
            brideAnswer: "늘행복하길"
        }
    ]

    const msg1 = "함께 있을 때 가장 나다운 모습이 되고,\n함께 있을 때 미래를 꿈꾸게 하는 사람을 만나\n평생을 함께 하고자 합니다.";
    const msg2 = "지금처럼 서로의 가장 친한 친구가 되어\n예쁘고 행복하게 잘 살겠습니다.";
    const msg3 = "귀한 걸음으로 그 시작을 함께 축복해주시면 \n 진심으로 감사하겠습니다";

    const lng = 126.668042647546;
    const lat = 37.5486351862208 ;

    const placeTelNum = "032)765-6000";

    const forCar = "네비게이션 : '아시아드웨딩컨벤션' 또는 '염곡로 725' 입력"
    const forParking = "인천아시아드주경기장 3번 게이트 앞 주차장 이용 (주차요금 무료)"
    const forBus = "우성아파트 [42717] : 24-1, 70, 인천e음86, 111, 111B, 302, 310\n우성아파트 [42718] : 24-1, 70, 595, 인천e음86, 111, 111B, 302, 302B, 308, 310\n인천아시아드주경기장(동문) [89354] : 3-2, 71, 인천e음86\n인천아시아드주경기장(동문) [89359] : 3-2, 71, 인천e음86";
    const forSubway = "셔틀버스 운행 (15분 간격 운행) \n공항철도, 인천 2호선 검암역 1번출구 횡단보도 건너편 승차\n 인천 2호선 아시아드경기장역 3번출구 앞 승차";
    
    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();
    }, []);

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);


    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex. (남궁)훈
    const getFirstKoName2 = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(2).join(''); 
    };

    if (!weddingData || !conceptStyle) return <Loading color={weddingData.pointColor}/>;
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#FF8A83"} loading={loading} />
            ) : (
            <>
            <Music concept={conceptStyle.concept}/>
            <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
            <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
            <Info_Spring weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
            <Letter title={"우리 결혼합니다"} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle}/>
            <Dday_Spring groomName={getFirstKoName2(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                <MotionWrapper initialY={50}>
                <GalleryList color={conceptStyle.pointColor} weddingData={weddingData} initCount={6} photoWidth={"153px"} hotoHeight={"235px"}/>
                    <MotionWrapper initialY={70}>
                    <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                        <MotionWrapper initialY={70}>
                            <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} conceptStyle={conceptStyle} btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.pointColor}/>
                            <MotionWrapper initialY={50}>
                                <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                                <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                                <Location_Desc forParking={forParking} forCar={forCar} forBus={forBus} forSubway={forSubway} conceptStyle={conceptStyle}/>
                                <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                                <Footer />
                            </MotionWrapper>
                        </MotionWrapper>
                    </MotionWrapper>
                </MotionWrapper>
            </>
            )}
        </div>
    );
};

export default SongJooHee;
